/**
 * Whether add-to-cart CTAs (buttons, cart trigger) should be visible.
 * Visible only for guests or users with customer role / consumer access.
 * Hidden for authenticated users who are only merchants/partners (no consumer access).
 */
import { useIdentity } from '~/composables/useIdentity'
import { holdsCustomerRole } from '~/utils/holdsCustomerRole'
import { resolveRoleNames } from '~/utils/resolveRoleNames'

export function useShowAddToCart() {
  const { isAuthenticated, identity } = useIdentity()
  const userStore = useUserStore()

  const showAddToCart = computed(() => {
    if (!isAuthenticated.value) return true // Guests can add to cart
    return userStore.hasConsumerAccess || isCustomerRole.value
  })

  const isCustomerRole = computed(() => {
    const resolvedUser = identity.value ?? userStore.user
    return holdsCustomerRole(resolveRoleNames(resolvedUser))
  })

  return { showAddToCart, isCustomerRole }
}
